import { Asset, AssetType } from "../../models/assets/asset";
import { Media } from "../../models/assets/media";
import {EntityType, mediaService} from "../../services/media-service";
import { Extension } from "../../constants/extension";
import { SCHOOL_NAMES } from "./school-names";

export const SNL_PHOTOS: Asset[] = [];

export const SNL_LOGO: Asset = {
        id: 5,
        name: "SNL School Logo",
        url: "/logos/snl.svg",
        type: AssetType.LOGO
};

export const SNL_COVER: Asset = {
        id: 6,
        name: "SNL School Cover",
        url: "/logos/snl.svg",
        type: AssetType.COVER
};

export const SNL_VIDEOS: Asset[] = [
    {
        id: 8,
        name: "SNL Program Overview",
        url: 'https://www.youtube.com/watch?v=7Kx0kcEajus',
        type: AssetType.VIDEO
    }
];

export const SNL_FILES: Asset[] = [
    {
        id: 8,
        name: "SNL Program PDF",
        url: mediaService.getMediaUrl(EntityType.SCHOOL, SCHOOL_NAMES.SNL, AssetType.PDF, Extension.PDF, 1),
        type: AssetType.PDF,
    }
];


export const SNL_MEDIA_EN: Media = {
    logo: SNL_LOGO,
    cover: SNL_COVER,
    videos: SNL_VIDEOS,
    photos: SNL_PHOTOS,
    files: SNL_FILES,
};


export const SNL_MEDIA_AR: Media = {
    logo: SNL_LOGO,
    cover: SNL_COVER,
    videos: SNL_VIDEOS,
    photos: SNL_PHOTOS,
    files: SNL_FILES,
};
